<script setup>
import IscWeb from '@/components/2023isc/isc.vue'
import IscMobile from '@/components/2023isc/isc-mobile.vue'
const IS_Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
const IS_H5 = IS_Mobile || window.innerWidth <= 768;
</script>
<template>
  <!-- /* 判读是从哪个入口进入 */ -->
  <IscMobile v-if="IS_H5" />
  <IscWeb v-else />
</template>
<style lang="scss" scoped></style>
